import React from 'react'

import {
    COLOR,
} from '../../../business-const/Color/Color'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    GridContainer,
    GridItem2,
    GridItem7,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'

import {
    ButtonVerResumoParcelas,
    ButtonVerParcelasMesAMes,
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import EstudoFormComparacaoFinanciamentoTabelaResumo from '../estudo-form/EstudoFormComparacaoFinanciamentoTabelaResumo'

import EstudoFormComparacaoFinanciamentoTabelaDetalhe from '../estudo-form/EstudoFormComparacaoFinanciamentoTabelaDetalhe'



const ComparacaoFinanciamentosChart = ( { values, estudo, report, indInicial, indFinal } ) => {

    const ComparacaoFinanciamentos = ( props ) => {

        const series = []

        const paletaCores = []


        if (values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista) {

            if (
                    !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                    values.objComparacaoFinanciamentos.valorPagtoParcelasFinanciamentoReceitaMensal
            ) {

                series.push(
                    {
                        name: LABEL.saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo,
                        type: 'line',
                        data: estudo.current.graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo,
                    },
                )
    
                paletaCores.push(COLOR().corChartPadraoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalNegativo)
    
                series.push(
                    {
                        name: LABEL.saldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo,
                        type: 'line',
                        data: estudo.current.graficoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo,
                    },
                )
    
                paletaCores.push(COLOR().corChartPadraoSaldoPagtoParcelasFinanciamentoSugeridoReceitaMensalPositivo)
            }

            series.push(
                {
                    name: LABEL.saldoPagtoFinanciamentoSugeridoAVistaNegativo,
                    type: 'line',
                    data: estudo.current.graficoSaldoPagtoFinanciamentoSugeridoAVistaNegativo,
                },
            )

            paletaCores.push(COLOR().corChartPadraoSaldoPagtoFinanciamentoSugeridoAVistaNegativo)

            series.push(
                {
                    name: LABEL.saldoPagtoFinanciamentoSugeridoAVistaPositivo,
                    type: 'line',
                    data: estudo.current.graficoSaldoPagtoFinanciamentoSugeridoAVistaPositivo,
                },
            )

            paletaCores.push(COLOR().corChartPadraoSaldoPagtoFinanciamentoSugeridoAVistaPositivo)
        }
        

        
        if (values.objComparacaoFinanciamentos.idFinanciamentoAlternativo) {

            if (estudo.current.graficoEcomoniaFinanciamentoSugerido[0] === null) {

                series.push(
                    {
                        name: LABEL.graficoEcomoniaFinanciamentoSugerido,
                        type: 'bar',
                        data: estudo.current.graficoEcomoniaFinanciamentoSugerido,
                    },
                )
    
                paletaCores.push(COLOR().corChartPadraoComparacaoFinanciamentoEconomiaFinanciamentoSugerido)
            }
    

            series.push(
                {
                    name: LABEL.graficoPerdaFinanciamentoSugerido,
                    type: 'bar',
                    data: estudo.current.graficoPerdaFinanciamentoSugerido,
                },
            )

            paletaCores.push(COLOR().corChartPadraoComparacaoFinanciamentoPerdaFinanciamentoSugerido)

            
            if (estudo.current.graficoEcomoniaFinanciamentoSugerido[0] !== null) {

                series.push(
                    {
                        name: LABEL.graficoEcomoniaFinanciamentoSugerido,
                        type: 'bar',
                        data: estudo.current.graficoEcomoniaFinanciamentoSugerido,
                    },
                )

                paletaCores.push(COLOR().corChartPadraoComparacaoFinanciamentoEconomiaFinanciamentoSugerido)
            }


            series.push(
                {
                    name: estudo.current.descricaoFinanciamentoAlternativo,//LABEL.financiamentoAlternativo,
                    type: 'line',
                    data: estudo.current.graficoFinanciamentoAlternativo,
                },
            )

            paletaCores.push(COLOR().corChartPadraoComparacaoFinanciamentoAlternativo)
        }

        if (estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao) {

            series.push(
                {
                    name: estudo.current.descricaoFinanciamentoSugeridoValorAluguelAposContemplacao,
                    type: 'line',
                    data: estudo.current.graficoFinanciamentoSugeridoValorAluguelAposContemplacao,
                },
            )

            paletaCores.push(COLOR().corChartPadraoFinanciamentoSugeridoValorAluguelAposContemplacao)
        }
       
        series.push(
            {
                name: estudo.current.descricaoFinanciamentoSugerido,//LABEL.financiamentoSugerido,
                type: 'line',
                data: estudo.current.graficoFinanciamentoSugerido,
            },
        )

        paletaCores.push(COLOR().corChartPadraoComparacaoFinanciamentoSugerido)


        const categories = estudo.current.anosFinanciamento

        const GridGrafico = report ? GridItem12 : GridItem11

        return (
            <div
                {...props}
            >
                <GridGrafico>
                    <ChartPadrao
                        titleText={''}
                        sempreExibirTitleText={true}
                        type={
                            !values.objComparacaoFinanciamentos.idFinanciamentoAlternativo &&
                            !values.objComparacaoFinanciamentos.valorPagtoFinanciamentoAVista
                                ?
                                    "line"
                                :
                                    "area"
                        }
                        series={series}
                        height={report ? 400 : 550}
                        stacked={false}
                        categories={categories}
                        categories2={estudo.current.anosFinanciamento}
                        paletaCores={paletaCores}
                        dataLabelsEnabled={true}
                        dataLabelsEnabledReport={true}
                        dataLabelsType='Idade'
                        dataLabelsInterval={1}
                        //dataLabelsDestaque={true}
                        //notInverseOrder={true}
                        strokeWidth={1.7}
                        toolTipX={true}
                        toolTipXTotal={false}
                        report={report}
                        formatoReport={values.formatoReport}
                        fillOpacity={0.65}
                    />
                </GridGrafico>
            </div>
        )
    }
    
    const ComparacaoFinanciamentoTabelaResumo = () => {

        return (
            <GridContainer
                className="justify-end"
            >
                <GridItem12>
                    <CustomizedDialogsPopup
                        maxWidth='xl'
                        popupTitle={LABEL.resumoParcelas}
                        PopupButton={ButtonVerResumoParcelas}
                        popupComponent={
                            <EstudoFormComparacaoFinanciamentoTabelaResumo
                                values={values}
                                estudo={estudo}
                            />
                        }
                    />
                </GridItem12>
            </GridContainer>
        )
    }

    const ComparacaoFinanciamentoTabelaDetalhe = () => {

        return (
            <GridContainer
                className="justify-end"
            >
                <GridItem12>
                    <CustomizedDialogsPopup
                        maxWidth='xl'
                        popupTitle={LABEL.parcelasMesAMes}
                        PopupButton={ButtonVerParcelasMesAMes}
                        popupComponent={
                            <EstudoFormComparacaoFinanciamentoTabelaDetalhe
                                values={values}
                                estudo={estudo}
                            />
                        }
                    />
                </GridItem12>
            </GridContainer>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <>
                        {!indInicial || indInicial === 0
                            ?
                                <>
                                    <ComparacaoFinanciamentos
                                        className='mt-0'
                                    />

                                    <GridItem12>
                                        <h2
                                            className={report ? 'mt-5' : 'mt-2'}
                                            align='center'
                                        >
                                            {LABEL.resumoParcelas}
                                        </h2>
                                    </GridItem12>
                                </>
                            :
                                <br/>
                        }

                        {/*report && !popup && (*/}
                            <EstudoFormComparacaoFinanciamentoTabelaResumo
                                values={values}
                                estudo={estudo}
                                report={report}
                                indInicial={indInicial}
                                indFinal={indFinal}
                            />
                        {/*})*/}
                    </>
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.analiseFinanciamentoSugerido
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <>
                                <GridContainer>
                                    <GridItem12>
                                        <div
                                            className='ml-10'
                                        >
                                            <ComparacaoFinanciamentos/>
                                        </div>
                                    </GridItem12>
                                </GridContainer>

                                <GridContainer>
                                    <GridItem7/>

                                    <GridItem2>
                                        <ComparacaoFinanciamentoTabelaResumo/>
                                    </GridItem2>
                                    
                                    <GridItem2>
                                        <ComparacaoFinanciamentoTabelaDetalhe/>
                                    </GridItem2>
                                </GridContainer>
                            </>
                        }
                        overflowX={false}
                    />
            }
        </GridItem12>
    )
}

export default ComparacaoFinanciamentosChart